import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import {
  Button,
  TablePagination,
  Typography,
  TextField,
  FormControl,
  Select,
  InputLabel,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import createInstance from "../../../api/axiosinstance";
// import COLORS from "../../Themes/Colours";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


const aiDishaApi = createInstance("DISHA");
const CssTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "white",
  },
  "& label": {
    color: "white",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "white",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
      borderRadius: 10,
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
    },
    "& .MuiInputBase-input": {
      color: "white",
    },
  },
}));

const CssFormControl = styled(FormControl)({
  "& label": {
    color: "white",
    "&.Mui-focused": {
      color: "white",
    },
  },
  "& .MuiInputBase-root": {
    color: "white",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
      borderRadius: 10,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    },
  },
});

const CssSelect = styled(Select)({
  "& .MuiSvgIcon-root": {
    color: "white",
    textAlign: "center",
  },
});

const CityManagement = () => {
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [activeCityList, setActiveCityList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deactivateId, setDeactiveId] = useState("");
  const [creationDate] = useState(new Date().toISOString());
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [actionType, setActionType] = useState("");
  const { COLORS } = useThemeMode();

  useEffect(() => {
    fetchActiveStates();
    fetchActiveCities();
  }, []);

  const fetchActiveStates = async () => {
    try {
      const response = await aiDishaApi.get("/Get_active_states");
      setStates(response.data);
      console.log("state data", response.data);
    } catch (error) {
      console.error("Error fetching active states:", error);
    }
  };

  const fetchDistrictsForState = async (state) => {
    setSelectedState(state);

    try {
      const districtResponse = await aiDishaApi.get(
        `/fetch_active_district_by_state?statename=${encodeURIComponent(state)}`
      );
      console.log("Districts data:", districtResponse.data);
      setDistricts(districtResponse.data);

      // Fetch cities for the selected state
      const cityResponse = await aiDishaApi.get(
        `/filter_cities?state_name=${state}`
      );
      console.log("Cities API Response:", cityResponse.data);

      if (Array.isArray(cityResponse.data)) {
        setCities(cityResponse.data);
      } else {
        console.error("Unexpected cities data format:", cityResponse.data);
        Toast.error("Error loading cities data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Toast.error(error.response?.data?.detail || "Failed to load data");
    }
  };

  //Fetch all cities (Active & Inactive) belonging to the selected state
  // const fetchAllCities = async (state) => {
  //   setSelectedState(state);
  //   try {
  //     const response = await aiDishaApi.get(`/filter_cities?state_name=${state}`);
  //     console.log("Cities API Response:", response.data); // Debug log

  //     if (Array.isArray(response.data)) {
  //       setCities(response.data);
  //     } else {
  //       console.error("Unexpected cities data format:", response.data);
  //       Toast.error("Error loading cities data");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching cities:", error);
  //     Toast.error("Failed to load cities");
  //   }
  // };

  const fetchActiveCities = async () => {
    await aiDishaApi
      .get("/Cities/all")
      .then((response) => {
        setActiveCityList(response.data);
        console.log("Active Cities.." + response.data);
      })
      .catch((error) => {
        console.error("Error fetching active cities" + error);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  const handleModalOpen = (cityId, action) => {
    setDeactiveId(cityId);
    setActionType(action);
    setIsModalOpen(true);
  };

  const handleConfirm = async (cityId) => {
    await handleDeactivateCity(cityId);
    setIsModalOpen(false);
  };
  const handleDeactivateCity = async (cityId, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";
      console.log("******" + cityId + "******");
      const response = await aiDishaApi.patch(
        `/Cities/${cityId}/active-inactive?status=${newStatus}`
      );
      if (response.status === 200) {
        Toast.success("City deactivated successfully");
        fetchActiveCities();
      }
    } catch (error) {
      console.error("Error deactivating city:", error);
      Toast.error("Failed to deactivate city");
    }
  };

  const header = [
    {
      city_id: "City ID",
      city_name: "City Name",
      state_name: "State Name",
      district_name: "District Name",
      creation_date: "Creation Date",
      action: "Action",
    },
  ];

  const paginatedRows = activeCityList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleClear = () => {
    setSelectedState("");
    setSelectedDistrict("");
    setSelectedCity("");
  };

  const handleCitySubmit = async (event) => {
    event.preventDefault();
    try {
      if (!selectedState || !selectedState.trim()) {
        Toast.error("State name cannot be empty");
        return;
      }

      if (!selectedCity) {
        Toast.error("Please select a city");
        return;
      }

      const response = await aiDishaApi.post(
        `/Cities?state_name=${selectedState}&district=${selectedDistrict}&city=${selectedCity}`,
        {
          Status: "Active", // <-- required body
        }
      );

      if (response.status === 200) {
        Toast.success("City activated successfully");
        handleClear();
        fetchActiveCities();
      }
    } catch (error) {
      Toast.error(error.response.data.detail)
      console.error("error",error)
    }
  };

  return (
    <div>
      <Box
        sx={{
          marginTop: "30px",
          alignItems: "center",
          // background: alpha("#B9B9B9", 0.2),
          background: COLORS.primary,
          borderRadius: "10px",
          padding: "15px",
        }}
      >
        <Box
          gridColumn="span 3"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
          >
            Add City
          </Typography>
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "16px", color: COLORS.text }}
          >
            Add the Name of the City
          </Typography>
        </Box>
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            alignItems: "center",
            // background: alpha("#B9B9B9", 0.2),
            background: COLORS.primary,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
              State Name <span style={{ color: COLORS.text }}>*</span>
            </Typography>
            <CssFormControl sx={{ width: "90%" }}>
              <InputLabel sx={{ display: "none" }}>Select State</InputLabel>
              <CssSelect
                id="demo-simple-select-outlined"
                size="small"
                value={selectedState}
                displayEmpty
                onChange={(e) => fetchDistrictsForState(e.target.value)}
                sx={{
                  width: "95%",
                  color: COLORS.text,
                  background: COLORS.background,
                  borderRadius: 2,
                  height: "35px",
                  "& .MuiOutlinedInput-root": {
                    color: COLORS.text,
                    background: COLORS.background,
                    borderRadius: 2,
                    height: "30px",
                    "& fieldset": {
                      borderColor: COLORS.border,
                      borderRadius: 2,
                    },
                    "&:hover fieldset": {
                      borderColor: COLORS.border,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: COLORS.border,
                    },
                    "&.Mui-disabled": {
                      "& fieldset": {
                        borderColor: COLORS.border,
                      },
                      "-webkit-text-fill-color": COLORS.text, // Ensures text stays white in disabled state
                    },
                  },
                  "& .MuiInputBase-input": {
                    color: COLORS.text,
                    padding: "12px 14px", // Proper padding so text doesn't hug the border
                  },
                  "& .MuiInputBase-input.Mui-disabled": {
                    color:COLORS.text,
                    "-webkit-text-fill-color": COLORS.text,
                    padding: "12px 14px",
                  },
                  // Hide the label completely if accidentally passed
                  "& .MuiInputLabel-root": {
                    display: "none",
                  },
                }}
                InputProps={
                  {
                    // No label, no shrink behavior
                  }
                }
                MenuProps={{
                  PaperProps: {
                    sx: {
                      bgcolor: COLORS.background,
                      "& .MuiMenuItem-root": {
                        color: COLORS.text,
                      },
                      "& .MuiMenuItem-root:hover": {
                        bgcolor: COLORS.secondary,
                      },
                      "& .MuiMenuItem-root.Mui-selected": {
                        bgcolor: COLORS.secondary,
                      },
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select State
                </MenuItem>
                {!states || states.length === 0 ? (
                  <MenuItem value="">No states available</MenuItem>
                ) : (
                  states.map((state) => (
                    <MenuItem key={state.state_id} value={state.state_name}>
                      {state.state_name}
                    </MenuItem>
                  ))
                )}
              </CssSelect>
            </CssFormControl>
          </Box>

          {/* <Box gridColumn="span 2" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }} >
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            Creation Date
          </Typography>
          <CssTextField
            value={creationDate + "(Auto)"}
            InputProps={{
              readOnly: true,
            }}
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "95%" }}
          />
        </Box> */}

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
              District Name <span style={{ color: COLORS.text }}>*</span>
            </Typography>
            <CssFormControl sx={{ width: "90%" }}>
              <InputLabel sx={{ display: "none" }}>Select District</InputLabel>
              <CssSelect
                id="demo-simple-select-outlined"
                size="small"
                displayEmpty
                value={selectedDistrict}
                onChange={(e) => setSelectedDistrict(e.target.value)}
                sx={{
                  width: "95%",
                  color: COLORS.text,
                  background: COLORS.background,
                  borderRadius: 2,
                  height: "35px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: COLORS.border,
                      borderRadius: 2,
                    },
                    "&:hover fieldset": {
                      borderColor: COLORS.border,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: COLORS.border,
                    },
                  },
                  "& .MuiSelect-select": {
                    padding: "12px 14px !important",
                    color: COLORS.text,
                    textAlign: "left",
                  },
                  "& .MuiSelect-icon": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root": {
                    display: "none",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      bgcolor: COLORS.background,
                      "& .MuiMenuItem-root": {
                        color: COLORS.text,
                      },
                      "& .MuiMenuItem-root:hover": {
                        bgcolor: COLORS.secondary,
                      },
                      "& .MuiMenuItem-root.Mui-selected": {
                        bgcolor: COLORS.secondary,
                      },
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  District Name
                </MenuItem>
                {!districts || districts.length === 0 ? (
                  <MenuItem value="">No districts available</MenuItem>
                ) : (
                  districts.map((district) => (
                    <MenuItem
                      key={district.District_Id}
                      value={district.District_Id}
                      sx={{ color: "#033538" }}
                    >
                      {district.district_name}
                    </MenuItem>
                  ))
                )}
              </CssSelect>
            </CssFormControl>
          </Box>
          <Box
            gridColumn="span 2"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
              City Name <span style={{ color: COLORS.text }}>*</span>
            </Typography>
            <CssFormControl sx={{ width: "90%" }}>
              <InputLabel sx={{ display: "none" }}>Select City</InputLabel>
              <CssSelect
                id="demo-simple-select-outlined"
                size="small"
                displayEmpty
                value={selectedCity}
                onChange={(e) => setSelectedCity(e.target.value)}
                sx={{
                  width: "95%",
                  color: COLORS.text,
                  background: COLORS.background,
                  borderRadius: 2,
                  height: "35px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: COLORS.border,
                      borderRadius: 2,
                    },
                    "&:hover fieldset": {
                      borderColor: COLORS.border,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: COLORS.border,
                    },
                  },
                  "& .MuiSelect-select": {
                    padding: "12px 14px !important",
                    color: COLORS.text,
                    textAlign: "left",
                  },
                  "& .MuiSelect-icon": {
                    color: COLORS.text,
                  },
                  "& .MuiInputLabel-root": {
                    display: "none",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      bgcolor: COLORS.background,
                      "& .MuiMenuItem-root": {
                        color: COLORS.text,
                      },
                      "& .MuiMenuItem-root:hover": {
                        bgcolor: COLORS.secondary,
                      },
                      "& .MuiMenuItem-root.Mui-selected": {
                        bgcolor: COLORS.secondary,
                      },
                    },
                  },
                }}
              >
                <MenuItem disabled>City</MenuItem>
                {!cities || cities.length === 0 ? (
                  <MenuItem value="">No cities available</MenuItem>
                ) : (
                  cities.map((city) => (
                    <MenuItem
                      key={city.city_id || city.city_name}
                      value={city || city.city_name} // Assuming city_name is the correct field
                      sx={{ color: "#033538" }}
                    >
                      {city || city.city_name}
                    </MenuItem>
                  ))
                )}
              </CssSelect>
            </CssFormControl>
          </Box>
          <Box
            gridColumn="span 2"
            sx={{
              marginTop: "auto",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: COLORS.button,
                "&:hover": {
                  color: COLORS.hover_btn,
                },
                width: "120px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              clear
            </Button>
          </Box>
          <Box
            gridColumn="span 2"
            sx={{
              marginTop: "auto",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            <Button
              onClick={handleCitySubmit}
              sx={{
                border: "1px solid",
                background: COLORS.button,
                "&:hover": {
                  background: COLORS.hover_btn,
                },
                color: COLORS.background,
                width: "120px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ background: COLORS.primary }}>
                  {header.map((n) => (
                    <TableRow key={n.city_id}>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {n.city_id}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {n.city_name}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {n.state_name}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {n.district_name}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {n.creation_date}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {n.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {paginatedRows.map((row) => (
                    <TableRow
                      key={row.City_Id}
                      sx={{ backgroundColor: COLORS.background, marginRight: "30px" }}
                    >
                      <TableCell
                        sx={{ color: COLORS.text, border: COLORS.secondary }}
                      >
                        {row.City_Id}
                      </TableCell>
                      <TableCell
                        sx={{ color: COLORS.text, border: COLORS.secondary }}
                      >
                        {row.city_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: COLORS.text, border: COLORS.secondary }}
                      >
                        {row.State_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: COLORS.text, border: COLORS.secondary }}
                      >
                        {row.district_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: COLORS.text, border: COLORS.secondary }}
                      >
                        {row.Creation_Date}
                      </TableCell>
                      <TableCell
                        sx={{ color: COLORS.text, border: COLORS.secondary }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor:
                              row.Status === "Active" ? COLORS.button_red_bg : COLORS.button_green_bg,
                            color: COLORS.text,
                            fontFamily: "poppins",
                            height: "24px",
                            padding: "2px 8px",
                            minWidth: "90px",
                            fontSize: "0.75rem",
                            "&:hover": {
                                background:
                                row.Status === "Active"
                                    ? COLORS.hover_red_btn      // hover when Active (Deactivate button)
                                    : COLORS.hover_green_btn,   // hover when Inactive (Activate button)
                              },
                          }}
                          onClick={() =>
                            handleModalOpen(row.City_Id, row.Status)
                          }
                          color="error"
                        >
                          {row.Status === "Active" ? "Deactivate" : "Activate"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={activeCityList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  background: COLORS.primary,
                  color: COLORS.text,
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
        <Modal open={isModalOpen} onClose={handleModalClose}>
          <Typography>
            Are you sure you want to deactivate this city?
          </Typography>
          <Button onClick={handleConfirm}>Confirm</Button>
          <Button onClick={handleModalClose}>Cancel</Button>
        </Modal>
      </Box>

      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title="city"
        action={() => handleDeactivateCity(deactivateId, actionType)}
        actionType={actionType === "Active" ? "Deactivate" : "Activate"}
      />
    </div>
  );
};

export default CityManagement;
